import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import config from "../../../config/app-config";

import { Box, Flex, useToast } from '@chakra-ui/react'
import '../styles/dsr-display.scss'
import { copyToUserClipboard, triggerLaunchdeckToast } from '../../global/helpers/global-helpers';

import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton'
import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal'
import { QRCodeSVG } from "qrcode.react";
import { MdOutlineShare } from 'react-icons/md'


function ShareProspectDsrModal({ pDsrId, handleCloseModal, dsrStatusRedux, isMobileView }) {

  const toast = useToast();
  // UX Management

  const renderCopyLinkText = () => {
    let copyLinkText = "";

    if (dsrStatusRedux === "active") {
      copyLinkText = `${config.displayUrl}/pdsr/${pDsrId}`;

    } else {
      copyLinkText = "Link has been deactivated as this Room is not yet published"
    }

    return copyLinkText;
  }

  const handleCopyLink = () => {
    if (pDsrId) {
      copyToUserClipboard(`${config.displayUrl}/pdsr/${pDsrId}`)

      toast(
        triggerLaunchdeckToast({
          useCase: "show-success-state",
          // bannerText: "",
          label: "Share link copied",
          isMobileView
        })
      )
    }

    if (!pDsrId) {
      toast(
        triggerLaunchdeckToast({
          useCase: "show-error-state",
          bannerText: "Error copying link",
          label: "Unfortunately something went wrong. Please try again later.",
          isMobileView
        })
      )
    }

  }

  const renderCopyInviteLinkButton = () => {
    if (dsrStatusRedux === "active") {
      return (
        <Flex mb='1.625em' mt='1em' w='100%' justify={['center', 'flex-end']}>
          <LaunchdeckButton bg='brand.500' w={['100%', 'auto']} color='white' fontSize='0.8em' py='0.4em' onClick={() => {
            handleCopyLink()
            handleCloseModal()
          }} label='Copy link' />
        </Flex>
      )
    } else return null;
  }

  function displayContent() {
    if (isMobileView) {
      return (
        <Flex justify='flex-start' px='1.5em' mt='1em' w='100%'>
          <Box w='100%'>
            <Flex w='100%' justify='center' align='center' my='2em'>
              <QRCodeSVG value={`${config.displayUrl}/pdsr/${pDsrId}`} />
            </Flex>

            <Box className='invite-link-container truncate-long-text' mt='0.5em' p='0.5em'>
              {renderCopyLinkText()}
            </Box>

            {renderCopyInviteLinkButton()}
          </Box>
        </Flex>
      )
    } else {
      return (
        <Flex justify='flex-start' px='1.5em' mt='1em' w='100%'>
          <Box w='100%'>
            <Box className='invite-link-container truncate-long-text' mt='0.5em' p='0.5em'>
              {renderCopyLinkText()}
            </Box>

            {renderCopyInviteLinkButton()}

            <Box display='flex' flexDirection='column' width='100%' justifyContent='center' alignItems='center' mb='2em'>
              <Box mb='1em'>or</Box>
              <QRCodeSVG value={`${config.displayUrl}/pdsr/${pDsrId}`} />
            </Box>

          </Box>
        </Flex>
      )
    }


  }

  return (
    <LaunchdeckModal
      title={<Flex gap='1em' justify='flex-start' align='center'>
        <Box as={MdOutlineShare} color='brand.500' boxSize="1.6em" />
        <Box color='white'>Share with others</Box>
      </Flex>}
      handleCloseModal={() => handleCloseModal()}
      showModal={true}
      maxW='35em'
    >
      {displayContent()}
    </LaunchdeckModal>
  )
}

function mapStateToProps(state) {
  return {
    dsrStatusRedux: state.dsrStatus.status,
    isMobileView: state.mobileViewMode.isMobileView
  };
}


export default withRouter(connect(mapStateToProps, null)(ShareProspectDsrModal));
